<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);
</script>
<template>
  <div
    class="tags"
    v-if="info.tags !== ''">
    <div
      v-for="item in info.tags"
      :key="item">
      {{ item }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tags {
  margin: 24px 0;
  div {
    border: rgb(218, 220, 224) 1px solid;
    text-align: center;
    height: 30px;
    line-height: 30px;
    border-radius: 25px;
    padding: 0 12px;
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
